export const CONTACT_FORM_URL = 'https://formspree.io/xvowekva';
export const ESTIMATION_FORM_URL = 'https://formspree.io/xvowekva';
